var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,9A2.5,2.5,0,1,0,6.5,6.5,2.5,2.5,0,0,0,9,9Zm0,1.25c-1.669,0-5,.838-5,2.5V14H14V12.75C14,11.088,10.669,10.25,9,10.25Z",
    transform: "translate(-4 0)",
    fill: "#3393b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9A2.5,2.5,0,1,0,6.5,6.5,2.5,2.5,0,0,0,9,9Zm0,1.25c-1.669,0-5,.838-5,2.5V14H14V12.75C14,11.088,10.669,10.25,9,10.25Z",
    transform: "translate(12 0)",
    fill: "#3393b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14A5,5,0,1,0,9,9,5,5,0,0,0,14,14Zm0,2.5c-3.337,0-10,1.675-10,5V24H24V21.5C24,18.175,17.338,16.5,14,16.5Z",
    transform: "translate(-1 -4)",
    fill: "#3393b9",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon_group.5791f35f17735f6ee717eefab40d8928.svg";
export { ForwardRef as ReactComponent };